import { Loader } from "@transfr-inc/dashboard-components";

import "./index.scss";

export const LazyLoading = () => {
  return (
    <div className="lazy-loading">
      <Loader fixed />
    </div>
  );
};
